(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbJsExtends", [], factory);
	else if(typeof exports === 'object')
		exports["sbJsExtends"] = factory();
	else
		root["sbJsExtends"] = factory();
})(window, function() {
return 